import type { Template } from "@/types";

export const SQ_05_H5_V0: Template[] = [
    {
        id: "sq-05-h5v0-01",
        name: "SQ 01 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_01.png",
        size: [1440, 720],
        style: {},
        slots: [        
            { id: "1", x: 105, y: 185, width: 251, height: 169, rotation: 0, imageRotation: 0 },
            { id: "2", x: 105, y: 362, width: 251, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 364, y: 185, width: 251, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 364, y: 362, width: 251, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 820, y: 185, width: 509, height: 346, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-05-h5v0-02",
        name: "SQ 02 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_02.png",
        size: [1440, 720],
        style: {},
        slots: [       
            { id: "1", x: 52, y: 135, width: 327, height: 219, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 362, width: 327, height: 219, rotation: 0, imageRotation: 0 },
            { id: "3", x: 387, y: 135, width: 326, height: 219, rotation: 0, imageRotation: 0 },    
            { id: "4", x: 387, y: 362, width: 326, height: 219, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 135, width: 660, height: 445, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-05-h5v0-03",
        name: "SQ 03 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_03.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 0, y: 119, width: 353, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 363, width: 353, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 119, width: 352, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 363, width: 352, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 119, width: 713, height: 479, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-05-h5v0-04",
        name: "SQ 04 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_04.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 53, y: 137, width: 326, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 363, width: 326, height: 219, rotation: 0, imageRotation: 0 },
            { id: "3", x: 387, y: 137, width: 665, height: 445, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1060, y: 137, width: 326, height: 218, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1060, y: 363, width: 326, height: 219, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h5v0-05",
        name: "SQ 05 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_05.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 137, y: 51, width: 221, height: 148, rotation: 0, imageRotation: 0 },
            { id: "2", x: 137, y: 207, width: 221, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 137, y: 362, width: 221, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 137, y: 517, width: 221, height: 147, rotation: 0, imageRotation: 0 },
            { id: "5", x: 366, y: 51, width: 920, height: 612, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h5v0-06",
        name: "SQ 06 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_06.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 60, y: 98, width: 590, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 60, y: 488, width: 192, height: 127, rotation: 0, imageRotation: 0 },        
            { id: "3", x: 260, y: 488, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 459, y: 488, width: 191, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 768, y: 160, width: 591, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h5v0-07",
        name: "SQ 07 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_07.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 0, y: 120, width: 716, height: 475, rotation: 0, imageRotation: 0 },
            { id: "2", x: 724, y: 120, width: 721, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 442, width: 236, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 968, y: 442, width: 236, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1212, y: 442, width: 236, height: 152, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h5v0-08",
        name: "SQ 08 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_08.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 65, y: 142, width: 591, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 778, y: 142, width: 591, height: 298, rotation: 0, imageRotation: 0 },
            { id: "3", x: 778, y: 447, width: 192, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 447, width: 192, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1178, y: 447, width: 191, height: 127, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h5v0-09",
        name: "SQ 09 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_09.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 223, y: 83, width: 267, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 223, y: 270, width: 267, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 223, y: 457, width: 267, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 853, y: 83, width: 435, height: 272, rotation: 0, imageRotation: 0 },
            { id: "5", x: 853, y: 363, width: 435, height: 272, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h5v0-10",
        name: "SQ 10 - H5V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h5_v0_10.png",
        size: [1440, 720],
        style: {},
        slots: [
            { id: "1", x: 166, y: 53, width: 385, height: 235, rotation: 0, imageRotation: 0 },
            { id: "2", x: 166, y: 295, width: 385, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 166, y: 537, width: 189, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 362, y: 537, width: 189, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 760, y: 154, width: 631, height: 411, rotation: 0, imageRotation: 0 }
        ],
    },
    

];

